import { dispatchCustomEventGlobally, initI18n } from 'www/utils'
import 'www/vue_components/common/LpuSchedule'
import { TARGET_ATTR_CACHED_NAME } from 'www/vue_components/common/LpuSchedule/constants'
import { TARGET_SELECTOR, TARGET_ATTR_ADDRESS_ID_NAME } from 'www/doctors.blocks/common/b-lpu-schedule/constants'

function initMobile() {
  function handleClickSchedule({ target }) {
    const targetElement = target.closest(TARGET_SELECTOR)

    if (targetElement) {
      dispatchCustomEventGlobally('lpu-schedule:selected', {
        addressId: targetElement.getAttribute(TARGET_ATTR_ADDRESS_ID_NAME),
      })
    }
  }

  document.addEventListener('click', handleClickSchedule)
}

async function initDesktop() {
  const { i18next, userLanguage } = await initI18n({ bundle: 'doctors.blocks/common/b-lpu-schedule' })
  const { default: Hint } = await import(/* webpackMode: "eager" */'www/modules/Hint')

  const hint = new Hint({
    isMobile: false,
    text: i18next.t('Загрузка...', userLanguage),
    target: TARGET_SELECTOR,
    modifier: 'b-lpu-schedule_hint',
    tippyOnShow: async instance => {
      const { reference } = instance

      if (reference.getAttribute(TARGET_ATTR_CACHED_NAME) === 'true') {
        return
      }

      dispatchCustomEventGlobally('lpu-schedule:selected', {
        addressId: reference.getAttribute(TARGET_ATTR_ADDRESS_ID_NAME),
        tooltip: instance,
      })
    },
    tippyOptions: {
      trigger: 'mouseenter',
      placement: 'bottom-start',
      maxWidth: 'none',
      interactiveBorder: 300,
    },
  })

  document.addEventListener('updateLpuSchedule', () => {
    hint.update()
  })
}

if (window.MOBILE_VERSION) {
  initMobile()
} else {
  initDesktop()
}
